export default {
    map_geofence_geofencegroups: "Geocercas",
    map_geofence_manage_geofence: "Administrar Geocercas",
    map_geofence_manage_visible: "Gestionar Visibilidad",
    map_geofence_manage_showAll: "Mostrar Todos",
    map_geofence_manage_hiddenAll: "Ocultar Todos",
};